import { render, staticRenderFns } from "./ShowCommentsButton.vue?vue&type=template&id=f044e21c&scoped=true&"
import script from "./ShowCommentsButton.vue?vue&type=script&lang=js&"
export * from "./ShowCommentsButton.vue?vue&type=script&lang=js&"
import style0 from "./ShowCommentsButton.vue?vue&type=style&index=0&id=f044e21c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f044e21c",
  null
  
)

export default component.exports